const createThrottle = (delayFn, cancelFn) => cb => {
  let id = null;
  const delayCallback = () => {
    id = null;
    cb();
  };
  return {
    fn: () => {
      if (id === null) {
        id = delayFn(delayCallback);
      }
    },
    cancel: () => {
      if (id !== null) {
        cancelFn(id);
      }
    }
  };
};
export const throttleAnimationFrame = createThrottle(globalThis.requestAnimationFrame, globalThis.cancelAnimationFrame);